import { useCallback } from 'react'
import axios from '../api/axios'
import useAuth from './useAuth'

function useRefreshData() {
  const { setAuth } = useAuth()

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('token')
    const currentPolicy = JSON.parse(localStorage.getItem('currentPolicy'))
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    if (token) {
      const response = await axios.get('v1/staff-hub/user', config)
      const session = response.data?.result || response.data
      const user = session?.user || (session?.contact_id ? session : null)
      if (!user) {
        throw new Error('Unable to restore session: user response is missing user data')
      }
      setAuth((prev) => {
        return { ...prev, token, user, schools: session.schools ?? prev.schools, currentPolicy: currentPolicy }
      })
      return token
    }
  }, [setAuth])
  return refresh
}

export default useRefreshData
